export enum IpType {
  ipv4 = 'inet',
  ipv6 = 'inet6'
}
